// Intent-based grouping axes for the marketplace; complements the
// production Quiz/Unscored/Content sections. A slide may belong to many.

export type CategoryId =
  | 'favorites'
  | 'all'
  | 'icebreaker'
  | 'discussion'
  | 'psych-safety'
  | 'brainstorm'
  | 'quiz'
  | 'polls'
  | 'content'

export type Category = {
  id: CategoryId
  label: string
  icon: string // Material Symbol name
  description: string
}

export const CATEGORIES: Category[] = [
  {
    id: 'favorites', label: 'My Bookmarks', icon: 'bookmark', description: 'Slides you saved for quick access',
  },
  {
    id: 'all', label: 'All slides', icon: 'apps', description: 'Browse every slide type',
  },
  {
    id: 'icebreaker', label: 'Icebreaker', icon: 'ac_unit', description: 'Warm the room up',
  },
  {
    id: 'discussion', label: 'Discussion', icon: 'forum', description: 'Spark conversation',
  },
  {
    id: 'psych-safety', label: 'Psych safety', icon: 'shield_person', description: 'Anonymous, low-stakes input',
  },
  {
    id: 'brainstorm', label: 'Brainstorm', icon: 'lightbulb', description: 'Generate ideas together',
  },
  {
    id: 'quiz', label: 'Quiz & games', icon: 'sports_esports', description: 'Score points, have fun',
  },
  {
    id: 'polls', label: 'Polls & Q&A', icon: 'poll', description: 'Gather opinions',
  },
  {
    id: 'content', label: 'Content', icon: 'article', description: 'Static slides',
  },
]
